module.exports = __webpack_public_path__ + "img/1_rain.e4e67ffd.jpg";